import { loadCookiefirst } from '@/external_scripts/cookiefirst'
import { loadElbwalker } from '@/external_scripts/elbwalker'
import { loadGtm } from '@/external_scripts/gtm'
import { loadNewRelic } from '@/external_scripts/newrelic.ts'
import { loadVWO } from '@/external_scripts/vwo'

const CF_CONSENT_EVENT = 'cf_consent'
const CF_CONSENT_INIT = 'cf_init'
const CF_CONSENT_LOADED = 'cf_consent_loaded'

export const injectScripts = async () => {
  window.addEventListener(CF_CONSENT_EVENT, () => {
    loadScripts()
  })
  window.addEventListener(CF_CONSENT_INIT, () => {
    loadScripts()
  })
  window.addEventListener(CF_CONSENT_LOADED, () => {
    loadScripts()
  })
  loadNewRelic()
  await loadCookiefirst()
}

async function loadScripts() {
  const { default: CF } = await import('@/services/helpers/CookieFirstHelper')
  const { default: CookieHelper } = await import(
    '@/services/helpers/CookieHelper'
  )

  loadElbwalker(CF.getConsent())

  if (
    CF.getPerformanceConsent() &&
    !CookieHelper.getCookie('original-customer-id')
  ) {
    await loadVWO()
  }

  if (CF.getFunctionalConsent()) {
    await loadGtm()
  }
}

injectScripts()
